var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { Eyebrow } from '../Eyebrow';
export const SideNavGroup = (_a) => {
    var { children, className, title } = _a, props = __rest(_a, ["children", "className", "title"]);
    const SideNavItemClasses = classnames('SideNavGroup', className);
    return (React.createElement("li", Object.assign({ className: SideNavItemClasses, "data-anvil-component": "SideNavGroup" }, props),
        title !== undefined && (React.createElement(Eyebrow, { className: "SideNavGroup__title", size: "medium" }, title)),
        React.createElement("menu", { className: "SideNavGroup__list" }, children)));
};
//# sourceMappingURL=SideNavGroup.js.map